import type { FC } from 'react'
import { memo } from 'react'

import { FormattedTimeStyled } from './styles/FormattedTimeStyled'
import { useFormatRelativeTime } from './useFormatRelativeTime'
import { useRelativeTimeTick } from './useRelativeTimeTick'

export interface IFormattedRelativeTimeProps {
  date: Date
  /**
   * Re-render at the next relative-time band boundary so the displayed
   * text stays accurate without a parent re-render. Opt-in.
   */
  autoUpdate?: boolean
}

export const FormattedRelativeTime: FC<IFormattedRelativeTimeProps> = memo(
  ({ date, autoUpdate = false }) => {
    useRelativeTimeTick(autoUpdate ? date : null)
    const formatRelativeTime = useFormatRelativeTime()
    return <FormattedTimeStyled>{formatRelativeTime(date)}</FormattedTimeStyled>
  }
)

FormattedRelativeTime.displayName = 'FormattedRelativeTime'
